import { getAscendantCodes } from "@l2r-front/l2r-utils"

import { useEquipmentTypes } from "../queries/equipment/useEquipmentsType"

export function useEquipmentAscendantCodes(code) {
    const { data: equipmentTypes } = useEquipmentTypes()

    return getAscendantCodes(code, equipmentTypes)
}